const NavFooter = () => {


  return false;

};

export default NavFooter;
